module.exports = __webpack_public_path__ + "img/GS_Profiles-Tamiel Sello.1cd443bb.png";